import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { MemberFeeAdjustmentDetailFeaturePage } from "..";

/** 可直接访问和刷新的独立成员费用详情。 */
export function OrderHandoverMemberFeeAdjustmentPage() {
  useEffect(() => {
    const previous = document.title;
    document.title = "成员费用调整详情 | 花儿研学";
    return () => { document.title = previous; };
  }, []);
  const { projectId = "", rosterId = "", memberId = "" } = useParams();
  const [searchParams] = useSearchParams();
  const customerQuoteId = searchParams.get("customerQuoteId")?.trim() || undefined;
  return <MemberFeeAdjustmentDetailFeaturePage key={`${projectId}/${rosterId}/${memberId}/${customerQuoteId ?? ""}`}
    params={{ projectId, rosterId, memberId, customerQuoteId }}
  />;
}
